import { ProjectFilesVm } from '../../project-intake/models/project-vm';

export class ProjectVerification {
    projectID?: number;    
    verificationID?: number;    
    projectTitle?: string;
    categoryName?: string;
    startDate?: Date;
    endDate?: Date;    
    status?: string;
    pwR_Number?: string;
    spoc?: string;
    agencyID!: number;
    agencyName?: string;
    fileName?: string;
    changedBy?: number;
    isVerificationStarted: boolean = false;
    lstProjectFiles?: ProjectFiles[];
    projectFilesCount?: number;
    isProcessedProject: boolean = false;
}

export class ProjectFiles {
    projectID?: number;
    projectFileID?: number;
    fileName?: string;
    filePath?: string;
    createdDate?: Date;
    status?: string;
}

export class FilterCriteria 
{
    projectTitle?: string;
    categoryName?: string;
    startDate1?: string;
    startDate2?: string;
    endDate1?: string;
    endDate2?: string;
    status?: string;
}